import Accordion from "./accordion"
import Alert from "./alert"
import Avatar from "./avatar"
import Badge from "./badge"
import Button from "./button"
import Checkbox from "./checkbox"
import CloseButton from "./close-button"
import Code from "./code"
import Modal from "./modal"
import Drawer from "./drawer"
import Heading from "./heading"
import Input from "./input"
import Link from "./link"
import FormLabel from "./form-label"
import Menu from "./menu"
import NumberInput from "./number-input"
import Radio from "./radio"
import Slider from "./slider"
import Select from "./select"
import Spinner from "./spinner"
import Switch from "./switch"
import Tabs from "./tabs"
import Tag from "./tag"
import Tooltip from "./tooltip"
import Kbd from "./kbd"
import PinInput from "./pin-input"
import Popover from "./popover"
import Form from "./form"
import Editable from "./editable"
import Progress from "./progress"
import Textarea from "./textarea"
import Stat from "./stat"
import Skeleton from "./skeleton"
import Breadcrumb from "./breadcumb"
import SkipLink from "./skip-link"

export default {
  Accordion,
  Button,
  Heading,
  Breadcrumb,
  Alert,
  Badge,
  Avatar,
  Link,
  Code,
  FormLabel,
  Spinner,
  Drawer,
  Menu,
  Tabs,
  Checkbox,
  Radio,
  Input,
  Tooltip,
  CloseButton,
  Slider,
  NumberInput,
  Switch,
  Tag,
  Modal,
  Kbd,
  Select,
  Textarea,
  PinInput,
  Popover,
  Form,
  Editable,
  Progress,
  Stat,
  Skeleton,
  SkipLink,
}
